import React from 'react';

import ActivityLogExportPage, { ActivityLogPageType } from './ActivityLogExport';
import { ActionCreators, ActivityType } from '../managers/managers';
import { useManagerParams } from '../managers/hooks/useManagerParams';

const activities = [
    { key: ActivityType.login, header: 'Logging in' },
    { key: ActivityType.logout, header: 'Logging out' },
    { key: ActivityType.passwordChange, header: 'Password Changes' },
    { key: ActivityType.otpSecretChange, header: 'OTP Secret Changes' },
    { key: ActivityType.managerDetails, header: 'This User Data Changes' },
    {
        key: ActivityType.entityUpdatePark,
        header: 'Updates Parked for Managers',
    },
    {
        key: ActivityType.entityUpdatePost,
        header: 'Updates Posted for Managers',
    },
    { key: ActivityType.userParked, header: 'User Parked' },
    { key: ActivityType.userPost, header: 'User Posted' },
    { key: ActivityType.phoneNumberChange, header: 'Phone Number Changes' },
];

const selectedOptions = activities.map((activity) => activity.key);

export const ManagerLogExport = () => {
    const { managerId } = useManagerParams();

    return (
        <ActivityLogExportPage
            activities={activities}
            entityId={managerId}
            entityType={ActivityLogPageType.Manager}
            exportActivityLog={ActionCreators.exportActivityLog}
            selectedOptions={selectedOptions}
        />
    );
};
